import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import ScientistError from 'common/illustrations/ScientistError';
import { Typography as T } from 'common/typography';

const Error = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
  margin-block-end: 20%;
`;

const StyledScientistError = styled(ScientistError)`
  width: 100%;
  max-width: 375px;
  margin-block-end: 32px;
`;

const ErrorHeading = styled(T.Heading3)`
  max-width: 476px;
  margin-block-end: 16px;
`;

const ErrorBody = styled(T.Body2)`
  max-width: 476px;
`;

const ErrorView = () => (
  <Error>
    <StyledScientistError />
    <ErrorHeading>
      <FormattedMessage id="venue-availability-status.error-heading" />
    </ErrorHeading>
    <ErrorBody>
      <FormattedMessage id="venue-availability-status.error-body" />
    </ErrorBody>
  </Error>
);

export default ErrorView;
